import http from '../../../lib/http';

export const FETCH_BAR_REPORT_SHIFTS_START = 'FETCH_BAR_REPORT_SHIFTS_START';
export const FETCH_BAR_REPORT_SHIFTS_ERROR = 'FETCH_BAR_REPORT_SHIFTS_ERROR';
export const FETCH_BAR_REPORT_SHIFTS_SUCCESS = 'FETCH_BAR_REPORT_SHIFTS_SUCCESS';

export const ADD_BAR_REPORT_SHIFT_START = 'ADD_BAR_REPORT_SHIFT_START';
export const ADD_BAR_REPORT_SHIFT_ERROR = 'ADD_BAR_REPORT_SHIFT_ERROR';
export const ADD_BAR_REPORT_SHIFT_SUCCESS = 'ADD_BAR_REPORT_SHIFT_SUCCESS';

export const DELETE_BAR_REPORT_SHIFT_START = 'DELETE_BAR_REPORT_SHIFT_START';
export const DELETE_BAR_REPORT_SHIFT_ERROR = 'DELETE_BAR_REPORT_SHIFT_ERROR';
export const DELETE_BAR_REPORT_SHIFT_SUCCESS = 'DELETE_BAR_REPORT_SHIFT_SUCCESS';

export const CLOSE_BAR_REPORT_SHIFT_START = 'CLOSE_BAR_REPORT_SHIFT_START';
export const CLOSE_BAR_REPORT_SHIFT_ERROR = 'CLOSE_BAR_REPORT_SHIFT_ERROR';
export const CLOSE_BAR_REPORT_SHIFT_SUCCESS = 'CLOSE_BAR_REPORT_SHIFT_SUCCESS';

export const PAY_BAR_REPORT_SHIFT_START = 'PAY_BAR_REPORT_SHIFT_START';
export const PAY_BAR_REPORT_SHIFT_ERROR = 'PAY_BAR_REPORT_SHIFT_ERROR';
export const PAY_BAR_REPORT_SHIFT_SUCCESS = 'PAY_BAR_REPORT_SHIFT_SUCCESS';

export const FETCH_BAR_REPORT_SHIFT_BARMANS_START = 'FETCH_BAR_REPORT_SHIFT_BARMANS_START';
export const FETCH_BAR_REPORT_SHIFT_BARMANS_ERROR = 'FETCH_BAR_REPORT_SHIFT_BARMANS_ERROR';
export const FETCH_BAR_REPORT_SHIFT_BARMANS_SUCCESS = 'FETCH_BAR_REPORT_SHIFT_BARMANS_SUCCESS';

export const BAR_REPORT_SHIFT_CHANGE_BARMAN_START = 'BAR_REPORT_SHIFT_CHANGE_BARMAN_START';
export const BAR_REPORT_SHIFT_CHANGE_BARMAN_ERROR = 'BAR_REPORT_SHIFT_CHANGE_BARMAN_ERROR';
export const BAR_REPORT_SHIFT_CHANGE_BARMAN_SUCCESS = 'BAR_REPORT_SHIFT_CHANGE_BARMAN_SUCCESS';

export const BAR_REPORT_SHIFT_CHANGE_VALUE_START = 'BAR_REPORT_SHIFT_CHANGE_VALUE_START';
export const BAR_REPORT_SHIFT_CHANGE_VALUE_ERROR = 'BAR_REPORT_SHIFT_CHANGE_VALUE_ERROR';
export const BAR_REPORT_SHIFT_CHANGE_VALUE_SUCCESS = 'BAR_REPORT_SHIFT_CHANGE_VALUE_SUCCESS';

export const CLEAR_BAR_REPORT_SHIFTS = 'CLEAR_BAR_REPORT_SHIFTS';
export const BAR_REPORT_SHIFTS_POPUP_TYPE = 'BAR_REPORT_SHIFTS_POPUP_TYPE';
export const OPEN_BAR_REPORT_BARMANS_POPUP = 'OPEN_BAR_REPORT_BARMANS_POPUP';

export function openBarReportBarmansPopup(open) {
    return {
        type: OPEN_BAR_REPORT_BARMANS_POPUP,
        payload: {open}
    }
}

export function barReportShiftsPopupType(shift) {
    return {
        type: BAR_REPORT_SHIFTS_POPUP_TYPE,
        payload: {shift}
    }
}

export function clearBarReportShifts() {
    return {
        type: CLEAR_BAR_REPORT_SHIFTS
    }
}

export function changeShiftHourrate(shiftId, value) {
    return {
        type: 'BAR_REPORT_SHIFT_CHANGE_VALUE',
        payload: {
            promise: postChangeShiftHourrate(shiftId, value)
        }
    };
}

export function changeShiftTime(shiftId, value, start, barId) {
    return {
        type: 'BAR_REPORT_SHIFT_CHANGE_VALUE',
        payload: {
            promise: postChangeShiftTime(shiftId, value, start, barId)
        }
    };
}

export function fetchBarReportShiftsBarmans() {
    return {
        type: 'FETCH_BAR_REPORT_SHIFT_BARMANS',
        payload: {
            promise: getBarReportShiftsBarmans()
        }
    };
}

export function fetchBarReportShifts(barId, limit, page) {
    return {
        type: 'FETCH_BAR_REPORT_SHIFTS',
        payload: {
            promise: getBarReportShifts(barId, limit, page)
        }
    };
}

export function changeShiftBarman(shiftId, barmanId) {
    return {
        type: 'BAR_REPORT_SHIFT_CHANGE_BARMAN',
        payload: {
            promise: pushChangeShiftBarman(shiftId, barmanId)
        }
    };
}

export function addBarReportShift(barId, limit) {
    return {
        type: 'ADD_BAR_REPORT_SHIFT',
        payload: {
            promise: addNewBarReportShift(barId, limit)
        }
    };
}

export function deleteBarReportShift(shiftId, barId, limit, page) {
    return {
        type: 'DELETE_BAR_REPORT_SHIFT',
        payload: {
            promise: delBarReportShift(shiftId, barId, limit, page)
        }
    };
}

export function closeBarReportShift(shiftId) {
    return {
        type: 'CLOSE_BAR_REPORT_SHIFT',
        payload: {
            promise: setCloseBarReportShift(shiftId)
        }
    };
}

export function payBarReportShift(cashboxId, shiftId) {
    return {
        type: 'PAY_BAR_REPORT_SHIFT',
        payload: {
            promise: setPayBarReportShift(cashboxId, shiftId)
        }
    };
}

async function setPayBarReportShift(cashboxId, shiftId) {
    const res = await http.get(`/app/shifts/pay/${cashboxId}/${shiftId}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function setCloseBarReportShift(shiftId) {
    const res = await http.get(`/app/shifts/close/${shiftId}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function delBarReportShift(shiftId, barId, limit, page) {
    const res = await http.delete(`/app/shifts/delete/${shiftId}/${barId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function addNewBarReportShift(barId, limit) {
    const res = await http.get(`/app/shifts/add-shift/${barId}/${limit}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function getBarReportShifts(barId, limit, page) {
    const res = await http.get(`/app/shifts/list/${barId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function getBarReportShiftsBarmans() {
    const res = await http.get(`/app/shifts/free-barmans`);
    if (res.status < 300) return res.json();
    throw res;
}

async function pushChangeShiftBarman(shiftId, barmanId) {
    const res = await http.post(`/app/shifts/update/field/${shiftId}/userEntityId`, {body: barmanId});
    if (res.status < 300) return res.json();
    throw res;
}

async function postChangeShiftHourrate(shiftId, value) {
    const res = await http.post(`/app/shifts/update/field/${shiftId}/hourRate`, {body: value});
    if (res.status < 300) return res.json();
    throw res;
}

async function postChangeShiftTime(shiftId, value, start, barId) {
    const res = await http.post(`/app/shifts/update/field/${shiftId}/${start ? barId + '/startShift' : 'endShift'}`, {body: value});
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/menu/report/shifts/actions.js